module.exports = __webpack_public_path__ + "img/unboxing-warning.64d456e3.webp";